(function($) {

  var cardCheck = $('.c-card--ticket label');

  $(cardCheck).click(function() {
    $(this).parents('.c-card__footer').toggleClass('c-card__footer--full');
  });
  
})(jQuery);